import { Application } from "@hotwired/stimulus"

import { captureError } from "../appsignal";

const application = Application.start()

// @appsignal/browser has no Stimulus plugin. Stimulus catches errors thrown in
// controllers and routes them here rather than letting them reach window, so
// without this override they would never be reported. Keep the console output
// Stimulus does by default.
application.handleError = (error, message, detail) => {
    console.error(message, error, detail)
    captureError(error, { componentName: detail && detail.identifier, stimulusMessage: message })
}

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
